(function () {
  'use strict';

  function initSection(section) {
    if (!section || section.dataset.letsToquiInitialized === 'true') return;

    section.dataset.letsToquiInitialized = 'true';

    // Reserved for future interaction logic.
  }

  function initAll(root) {
    var scope = root || document;

    if (
      scope.nodeType === 1 &&
      scope.matches &&
      scope.matches('.lets-toqui')
    ) {
      initSection(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll('.lets-toqui')
        .forEach(initSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();